import React, { useState } from 'react';

// Absage auf eine Schicht-Meldung. Die Leitung waehlt einen Baustein oder
// schreibt selbst – der Text geht 1:1 als WhatsApp raus, damit niemand nur ein
// stummes „abgelehnt" erlebt.
export const DECLINE_PRESETS = [
  'Die Schicht hat leider jemand anderes bekommen.',
  'Du arbeitest an dem Tag ja schon – deshalb passt es diesmal nicht.',
  'Für den Tag sind wir inzwischen vollständig besetzt.',
  'Die Pause zu deiner anderen Schicht wäre zu kurz – das geht leider nicht.',
];

export default function ClaimDeclineModal({ box, onClose, onConfirm }) {
  const [note, setNote] = useState('');
  if (!box) return null;
  const { claim, offer } = box;
  const label = `${new Date(offer.date + 'T12:00').toLocaleDateString('de-DE', { weekday: 'short', day: '2-digit', month: '2-digit' })} · ` +
    `${String(offer.from).padStart(2, '0')}:00–${String(offer.to === 25 ? 1 : offer.to).padStart(2, '0')}:00 · ${offer.station}`;

  return (
    <div className="modal show d-block" style={{ background: 'rgba(0,0,0,.5)' }} onClick={onClose}>
      <div className="modal-dialog modal-dialog-centered" onClick={(e) => e.stopPropagation()}>
        <div className="modal-content">
          <div className="modal-header py-2">
            <h6 className="modal-title">Absage an {claim.name}</h6>
            <button type="button" className="btn-close" onClick={onClose} />
          </div>
          <div className="modal-body">
            <div className="text-muted small mb-2">{label}</div>
            <div className="d-flex flex-column gap-1 mb-2">
              {DECLINE_PRESETS.map((p) => (
                <button key={p} type="button"
                  className={`btn btn-sm text-start ${note === p ? 'btn-primary' : 'btn-outline-secondary'}`}
                  onClick={() => setNote(p)}>{p}</button>
              ))}
            </div>
            <textarea className="form-control" rows={3} value={note} placeholder="… oder eigenen Text schreiben"
              onChange={(e) => setNote(e.target.value)} />
            <div className="form-text">Wird genau so per WhatsApp verschickt – eingebettet in „Danke für deine Meldung …“.</div>
          </div>
          <div className="modal-footer py-2">
            <button className="btn btn-outline-secondary btn-sm" onClick={() => onConfirm('', false)}>
              Nur absagen (ohne Nachricht)
            </button>
            <button className="btn btn-primary btn-sm" disabled={!note.trim()} onClick={() => onConfirm(note.trim(), true)}>
              Absagen &amp; WhatsApp schicken
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
